const returnObject = (name, pos, numberComputations, symbol, father) => {
  return {
    name: name,
    pos: pos,
    numberComputations: numberComputations,
    symbol: symbol,
    final: false,
    initial: false,
    father: father,
    children: [],
  };
};

const sortByNumberComputation = (array) => {
  return array.sort((a, b) => a.numberComputations - b.numberComputations);
};

const createNewList = (array, finals, initial) => {
  let newArray = [];
  console.log(finals);
  array.forEach((element) => {
    const { actualState, pos, numberComputations, symbol, father } = element;
    const obj = returnObject(
      actualState.name,
      pos,
      numberComputations,
      symbol,
      father
    );
    finals.forEach((el) => {
      if (el.name === obj.name) {
        obj.final = true;
      }
    });
    if (obj.name === initial.name) {
      obj.initial = true;
    }

    newArray.push(obj);
  });
  return newArray;
};

const formatList = (array, finals, initial) => {
  let list = createNewList(array, finals, initial);

  list = sortByNumberComputation(list);
  const len = list.length;
  for (let i = len - 1; i >= 0; i--) {
    const element = list[i];
    for (let k = i; k >= 0; k--) {
      const dad = list[k];
      if (
        dad.numberComputations === element.numberComputations - 1 &&
        dad.name === element.father
      ) {
        const index = list.indexOf(dad);
        list[index].children.push(element);
      }
    }
  }
  const object = list[0];
  return object;
};

const formatWordArray = (word) => {
  let arrayTape = [];

  for (let i = 0; i < word.length; i++) {
    arrayTape.push(word[i]);
  }
  return arrayTape;
};

export default {
  formatList,
  formatWordArray,
};
